"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonInline = exports.ButtonIcon = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _button = require("@remote-com/norma/core/button");

var _link = _interopRequireDefault(require("next/link"));

var __jsx = _react["default"].createElement;

// Lodash partition but for Objects.
// https://github.com/lodash/lodash/issues/3172#issuecomment-352773355
var partitionObject = function partitionObject(obj, filterFn) {
  return Object.keys(obj).reduce(function (result, key) {
    result[filterFn(obj[key], key) ? 0 : 1][key] = obj[key];
    return result;
  }, [{}, {}]);
}; // NextLink props: https://nextjs.org/docs/api-reference/next/link


var nextLinkPropsList = ['href', 'as', 'passHref', 'prefetch', 'replace', 'scroll', 'shallow', 'getStaticProps', 'getServerSideProps', 'getInitialProps', 'locale'];

var extractNextLinkProps = function extractNextLinkProps(props) {
  var _partitionObject = partitionObject(props, function (propValue, propName) {
    return nextLinkPropsList.includes(propName);
  }),
      _partitionObject2 = (0, _slicedToArray2["default"])(_partitionObject, 2),
      nextLinkProps = _partitionObject2[0],
      buttonProps = _partitionObject2[1];

  return {
    nextLinkProps: nextLinkProps,
    buttonProps: buttonProps
  };
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withNextLink(BtnComponent) {
  function BtnWithNextJS(props) {
    if (!props.href) {
      return __jsx(BtnComponent, props);
    }

    var _extractNextLinkProps = extractNextLinkProps(props),
        nextLinkProps = _extractNextLinkProps.nextLinkProps,
        buttonProps = _extractNextLinkProps.buttonProps;

    return __jsx(_link["default"], (0, _extends2["default"])({}, nextLinkProps, {
      passHref: true
    }), __jsx(BtnComponent, buttonProps));
  }

  BtnWithNextJS.displayName = "withNextLink".concat(getDisplayName(BtnComponent));
  return BtnWithNextJS;
}

var Button = withNextLink(_button.Button);
exports.Button = Button;
var ButtonIcon = withNextLink(_button.ButtonIcon);
exports.ButtonIcon = ButtonIcon;
var ButtonInline = withNextLink(_button.ButtonInline);
exports.ButtonInline = ButtonInline;